module.exports = __webpack_public_path__ + "static/img/profile_banner.e271569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile_banner.jpg
// module id = 01S4
// module chunks = 1